import BlockService from "./Blocks/blocks";
import OverViewService from "./Overview";
import TransactionService from "./Transactions/transactions";

export const transactionAPI = new TransactionService();

export const blockAPI = new BlockService();

export const overViewAPI = new OverViewService();